import React, { useEffect, useState } from "react";
import bgImg from "../../assets/wallpaper/new.png";
import { BlogTrans, ToasterTrans } from "../../utils/translations";
import { useAppContext } from "../../context/AppContext";
import { getPosts } from "../../services/postService";
import { subscribeToNewsletter } from "../../services/newsletterService";
import { trackPixelEvent } from "../../utils/pixel";

const categories = ["all", "tips", "inspo"];

const BlogPage = () => {
  const { language, setToaster, user } = useAppContext();
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [posts, setPosts] = useState([]);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const data = await getPosts();
        setPosts(data);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPosts();
  }, []);

  const filteredPosts = posts.filter(
    (post) =>
      selectedCategory === "All" || post.category.includes(selectedCategory)
  );

  const handleSubscribe = async () => {
    if (!email || !email.includes("@")) {
      setToaster({
        message: ToasterTrans[language].invalidEmail,
        type: "error",
        show: true,
      });
      return;
    }

    try {
      await subscribeToNewsletter(email);
      setEmail("");
      setToaster({
        message: ToasterTrans[language].subscribed,
        type: "success",
        show: true,
      });
    } catch (err) {
      if (err.response?.status === 409) {
        setEmail("");
        setToaster({
          message: ToasterTrans[language].alreadySubscribed,
          type: "info",
          show: true,
        });
      } else {
        setToaster({
          message: ToasterTrans[language].subscribeError,
          type: "error",
          show: true,
        });
      }
    }
  };

  return (
    <main className="flex min-h-screen flex-col">
      <div className="h-[55vh] w-full overflow-hidden">
        <img
          src={bgImg}
          alt="Description"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="w-11/12 lg:w-10/12 mx-auto mb-10">
        <h1>{BlogTrans[language].header}</h1>

        {/* Category Filters */}
        <div className="flex justify-center space-x-4 my-6">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm text-white font-medium transition ${
                selectedCategory === cat ? "bg-brown" : "bg-beige"
              }`}
            >
              {BlogTrans[language][cat]}
            </button>
          ))}
        </div>

        {/* Blog Posts Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPosts.map((post) => (
            <div
              key={post._id}
              className="bg-white rounded-2xl shadow-md overflow-hidden"
            >
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-56 object-cover"
              />
              <div className="p-5">
                <span className="text-sm text-gray-500">
                  {new Intl.DateTimeFormat("en-GB", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                  }).format(new Date(post.date))}
                </span>
                <h3 className="text-xl font-semibold mt-2 text-center">
                  {post.title}
                </h3>
                <p className="text-gray-600 mt-2 text-left">{post.excerpt}</p>
                <a
                  href={`/blog/${post._id}`}
                  onClick={() => trackPixelEvent("ViewBlogPost", { postId: post._id })}
                  className="text-[#D27B5E] font-semibold mt-3 inline-block"
                >
                  {BlogTrans[language].readMore}
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Newsletter Subscription */}
        {!user?.subscribedToNewsletter && ( // ✅ Don't show if already subscribed
          <div className="mt-12 bg-white p-6 rounded-2xl shadow-lg text-center max-w-xl mx-auto">
            <h3 className="text-xl font-semibold text-center">
              {BlogTrans[language].newsLetter}
            </h3>
            <p className="text-gray-600 mt-2">
              {BlogTrans[language].subscribeSubText}
            </p>

            <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:gap-0">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={BlogTrans[language].email}
                className="p-3 rounded-lg sm:rounded-l-lg sm:rounded-r-none border border-gray-300 focus:outline-none flex-1"
              />
              <button
                onClick={handleSubscribe}
                className="bg-[#D27B5E] text-white px-5 py-3 rounded-lg sm:rounded-r-lg sm:rounded-l-none"
              >
                {BlogTrans[language].subscribe}
              </button>
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default BlogPage;
